import { searchMainBook } from './api';

export const autoComplete = async (term, userStore) => {
  const result = await searchMainBook(userStore.token, term);
  const list = [];
  for (let data of result.data.data) {
    list.push(data);
  }
  return list;
};
